<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Restschuld na verkoop van de woning
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je na 28 oktober 2012, maar voor 1 januari 2018 de woning verkocht voor een lager bedrag dan de
                eigenwoningschuld op deze woning? Dan hebt je een restschuld. De rente over deze restschuld mag je
                gedurende 15 jaar aftrekken. Het maakt hierbij niet uit of je een andere woning koopt of een huis gaat
                huren. Om de rente te mogen aftrekken, ben je ook niet verplicht de (rest)schuld af te lossen.
                <div class="space10"></div>

                Heb je een schenking ontvangen voor de aflossing van een restschuld? Dan vermindert die schenking de
                restschuld en kun je de rente over (dat deel van) die restschuld niet meer aftrekken.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Situaties die gelijk zijn aan verkoop
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De eigenwoningregeling eindigt meestal bij overdracht van de woning. Dat is meestal door verkoop, maar
                het kan ook door schenking. Je hebt de woning dan 'vervreemd'.
                <div class="space10"></div>

                Daarnaast eindigt de eigenwoningregeling bijvoorbeeld in de volgende situaties:
                <li class="list">de eigen woning is niet langer je hoofdverblijf, maar wordt je tweede woning. De woning gaat van box
                    1 over naar box 3.
                </li>
                <li class="list">je gaat de woning verhuren. Dat geldt niet voor tijdelijke verhuur.</li>
                <li class="list">je brengt de eigen woning van het privévermogen over naar het ondernemingsvermogen.</li>
                <li class="list">je eigen woning is verloren gegaan, bijvoorbeeld door brand.</li>
                <li class="list">je bent gescheiden of gaat uit elkaar en:<br/>
                    - je hebt de woning 2 jaar geleden verlaten<br/>
                    - je hebt de woning nog geen 2 jaar geleden verlaten, maar je partner woont er inmiddels ook niet
                    meer
                </li>
                <li class="list">je bent verhuisd en:<br/>
                    - de oude woning is nog niet verkocht aan het einde van het 3e kalenderjaar, nadat je deze woning
                    verliet<br/>
                    - de oude woning is niet meer bestemd voor verkoo<br/>
                    - de oude woning staat niet meer leeg
                </li>
                <li class="list">je kunt niet meer aannemelijk maken dat je nieuwe woning leeg staat of in aanbouw is en deze je
                    uiterlijk 31 december 2027 als eigen woning ter beschikking zal staan.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Hoogte restschuld bij situatie gelijk aan verkoop
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Geldt voor de woning de eigenwoningregeling niet meer? En heb je die woning niet verkocht? Dan geldt als
                verkoopprijs de waarde in het economisch verkeer op het moment dat de woning niet meer onder de
                eigenwoningregeling viel.
                <div class="space10"></div>

                Is de eigenwoningschuld hoger? Dan is het verschil tussen de eigenwoningschuld en de waarde in het
                economisch verkeer de restschuld. De rente over deze restschuld mag je niet aftrekken. De schuld behoort
                vanaf het moment dat de woning geen eigen woning meer is in box 3.
            </div>
        </div>
    </div>

</div>
